/**
 * PDF da propriedade (página pública de hotel) — SERVER-SIDE.
 * Endpoint PÚBLICO: GET /api/v1/public/hotel/:token/pdf (mesmo esquema do PDF da
 * cotação: blob → ver/baixar; ?inline=1 para visualizar). Busca via cliente `api`.
 */
import api from "../Services/api";

const HOTEL_PDF_PATH = (token) => `/api/v1/public/hotel/${token}/pdf`;

const fetchPdf = (token, { inline = false, a } = {}) =>
	api.get(HOTEL_PDF_PATH(token), {
		responseType: "blob",
		params: { ...(inline ? { inline: 1 } : {}), ...(a ? { a } : {}) },
	});

const filenameFrom = (res, token) => {
	const cd = res.headers?.["content-disposition"] || "";
	const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
	if (match && match[1]) {
		try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
	}
	return `hotel-${String(token).slice(0, 8)}.pdf`;
};

/** Baixa o PDF do hotel. */
export const downloadHotelPdf = async (token, a) => {
	if (!token) return;
	const res = await fetchPdf(token, { a });
	const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
	const anchor = document.createElement("a");
	anchor.href = url;
	anchor.download = filenameFrom(res, token);
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();
	setTimeout(() => URL.revokeObjectURL(url), 1500);
};

/** Blob URL p/ exibir num iframe/modal. Caller revoga ao fechar. */
export const fetchHotelPdfUrl = async (token, a) => {
	if (!token) return null;
	const res = await fetchPdf(token, { inline: true, a });
	return URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
};

/** Abre o PDF numa nova aba (mobile). */
export const viewHotelPdf = async (token, a) => {
	if (!token) return;
	const win = window.open("", "_blank");
	try {
		const res = await fetchPdf(token, { inline: true, a });
		const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
		if (win && !win.closed) win.location.href = url;
		else { const anchor = document.createElement("a"); anchor.href = url; anchor.download = filenameFrom(res, token); document.body.appendChild(anchor); anchor.click(); anchor.remove(); }
		setTimeout(() => URL.revokeObjectURL(url), 60000);
	} catch (e) {
		if (win && !win.closed) win.close();
		throw e;
	}
};

export default downloadHotelPdf;
